module.exports = __webpack_public_path__ + "static/image/company/pc/image_vision_3.ver2_0_2.png?c1901dba";